export default "__VITE_ASSET__a054429e__"